/**
 * A progress ring in the Apple Fitness manner: a brand-green arc over the track, from 12 o'clock, with whatever
 * goes in the middle (a number, an icon) as children. Decorative: the numbers it stands for are in the text.
 */
export const CalorieRing = ({ share, size, stroke, className = '', children }) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const fraction = Math.min(Math.max(share || 0, 0), 1);
  const center = size / 2;

  return (
    <span className={`mt-cal-ring ${className}`} style={{ width: size, height: size }}>
      <svg className="mt-cal-ring__svg" width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <circle className="mt-cal-ring__track" cx={center} cy={center} r={radius} fill="none" strokeWidth={stroke} />
        {fraction > 0 && (
          <circle
            className="mt-cal-ring__arc"
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference}
            // A sliver stays visible for the first few calories
            strokeDashoffset={circumference * (1 - Math.max(fraction, 0.02))}
            style={{ '--mt-ring-full': circumference }}
          />
        )}
      </svg>
      {children}
    </span>
  );
};
